import jsonStringfy from 'fast-json-stable-stringify';
import { Md5 } from 'ts-md5';
export default function hashObject(obj) {
  return Md5.hashStr(jsonStringfy(obj));
}